// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/store/index.js'
import VueFroala from 'vue-froala-wysiwyg'
import Notifications from 'vue-notification'
import VueGridLayout from 'vue-grid-layout'
import Meta from 'vue-meta'

// Require Froala Editor js file.
require('froala-editor/js/froala_editor.pkgd.min')
require('froala-editor/js/languages/fr.js')

// Require Froala Editor css files.
require('froala-editor/css/froala_editor.pkgd.min.css')
require('font-awesome/css/font-awesome.css')
require('froala-editor/css/froala_style.min.css')
// additionnal js file
require('@/plugins.js')

Vue.use(VueFroala)
Vue.use(Notifications)
Vue.use(Meta)
Vue.use(VueGridLayout)

Vue.config.productionTip = false

export const state = new Vue()

/* eslint-disable no-new */
var app = new Vue({
  el: '#app',
  router,
  store,
  state,
  template: '<App/>',
  components: { App, state }
})
global.app = app // Define the app globally
global.debug = process.env.NODE_ENV !== 'production'




// WEBPACK FOOTER //
// ./src/main.js